import React from 'react';
import { useNavigate } from 'react-router-dom';

function Profile({ user, profile, setProfile, profileLoading, profileMessage, error, saveProfile, onSignOut }) {
  const navigate = useNavigate();
  return (
      <div className="page-content">
        <h1 className="profile-title">Profile</h1>

      <div className="profile-content">
        {/* Avatar */}
        <div className="profile-avatar">
          <span>{profile.username ? profile.username[0].toUpperCase() : ''}</span>
        </div>
        <h2 className="profile-section-title">Current Profile</h2>

        <div className="profile-row">
          <span className="profile-label">
            Email
          </span>
          <span className="profile-value">{profile.email || user.email}</span>
        </div>

        <div className="profile-row">
          <span className="profile-label">
            Username
          </span>
          <span className="profile-value">{profile.username}</span>
        </div>

        <div className="profile-row">
          <span className="profile-label">
            School
          </span>
          <span className="profile-value">{profile.school || "Not set"}</span>
        </div>

        <div className="profile-row">
          <span className="profile-label">
            Major
          </span>
          <span className="profile-value">{profile.major || "Not set"}</span>
        </div>

        <div className="profile-row">
          <span className="profile-label">
            Graduation Year
          </span>
          <span className="profile-value">{profile.gradYear || "Not set"}</span>
        </div>

        <button
          className="profile-update-btn"
          onClick={() => navigate("/settings")}
        >
          [update profile]
        </button>
      </div>

      <div className="profile-logout">
        <button onClick={onSignOut}>[log out]</button>
      </div>

      {profileMessage && <p className="success-message">{profileMessage}</p>}
      {error && <p className="error-message">{error}</p>}
    </div>
  );
}

export default Profile;


